<template>
  <div>
    <encabezado-filtros
      titulo="Inicio"
      subtitulo="Resumen del gimnasio"
      :con-busqueda="false"
    >
      <template #filtros>
        <v-btn-toggle
          v-model="periodo"
          color="primary"
          density="comfortable"
          mandatory
        >
          <v-btn value="hoy">Hoy</v-btn>
          <v-btn value="semana">Semana</v-btn>
          <v-btn value="mes">Mes</v-btn>
          <v-btn value="anio">Año</v-btn>
        </v-btn-toggle>
      </template>
    </encabezado-filtros>

    <cartas-personalizadas :cartas="datosVisitasOrdenados" />
    <v-row class="mt-3">
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasVisitasHora"
          :valores="valoresVisitasHora"
          color="#D81B60"
          titulo="Visitas por hora"
          subtitulo="Visitas registras por hora"
          tipo="barra"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasVisitasSemana"
          :valores="valoresVisitasSemana"
          color="#E53935"
          titulo="Visitas semana"
          subtitulo="Visitas registras en esta semana"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasVisitasMes"
          :valores="valoresVisitasMes"
          color="#3949AB"
          titulo="Visitas mes"
          subtitulo="Visitas registras por días de este mes"
        />
      </v-col>
    </v-row>

    <cartas-personalizadas :cartas="datosPagosOrdenados" class="mt-3" />
    <v-row class="mt-3">
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasPagosSemana"
          :valores="valoresPagosSemana"
          color="#43A047"
          titulo="Pagos semana"
          subtitulo="Pagos registrados esta semana"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasPagosMes"
          :valores="valoresPagosMes"
          color="#FB8C00"
          titulo="Pagos mes"
          subtitulo="Pagos registrados este mes"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="4">
        <grafico-tendencia
          :etiquetas="etiquetasPagosMeses"
          :valores="valoresPagosMeses"
          color="#1E88E5"
          titulo="Pagos por meses"
          subtitulo="Pagos registrados por meses de este año"
        />
      </v-col>
    </v-row>

    <v-overlay :model-value="cargando">
      <v-progress-circular size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import HttpService from "../Servicios/HttpService";
import Utiles from "../Servicios/Utiles";
import CartasPersonalizadas from "./Dialogos/CartasPersonalizadas.vue";
import EncabezadoFiltros from "./Dialogos/EncabezadoFiltros.vue";
import GraficoTendencia from "./Dialogos/GraficoTendencia.vue";
export default {
  name: "InicioComponent",
  components: { CartasPersonalizadas, EncabezadoFiltros, GraficoTendencia },

  data: () => ({
    cargando: false,
    periodo: "semana",
    datosVisitas: [],
    datosPagos: [],
    etiquetasVisitasHora: [],
    valoresVisitasHora: [],
    etiquetasVisitasSemana: [],
    valoresVisitasSemana: [],
    etiquetasVisitasMes: [],
    valoresVisitasMes: [],
    etiquetasPagosSemana: [],
    valoresPagosSemana: [],
    etiquetasPagosMes: [],
    valoresPagosMes: [],
    etiquetasPagosMeses: [],
    valoresPagosMeses: [],
  }),

  computed: {
    // El backend de inicio.php entrega hoy/semana/mes en una sola
    // respuesta (sin parámetro de período), así que "periodo" no
    // vuelve a consultar la API: solo reordena, en pantalla, las
    // tarjetas ya obtenidas para destacar la que coincide con el
    // período elegido. No existe un dato anual agregado, por lo que
    // "anio" simplemente deja el orden original de las tarjetas.
    datosVisitasOrdenados() {
      return this.ordenarPorPeriodo(this.datosVisitas);
    },

    datosPagosOrdenados() {
      return this.ordenarPorPeriodo(this.datosPagos);
    },
  },

  mounted() {
    this.obtenerDatos();
  },

  methods: {
    ordenarPorPeriodo(items) {
      if (!items || items.length === 0) return items;
      const claves = { hoy: "hoy", semana: "semana", mes: "mes" };
      const clave = claves[this.periodo];
      if (!clave) return items;
      const indice = items.findIndex((item) =>
        item.nombre.toLowerCase().includes(clave)
      );
      if (indice <= 0) return items;
      const copia = [...items];
      const [seleccionada] = copia.splice(indice, 1);
      copia.unshift(seleccionada);
      return copia;
    },

    obtenerDatos() {
      this.cargando = true;
      HttpService.obtenerConDatos(
        {
          metodo: "obtener",
        },
        "inicio.php"
      ).then((resultado) => {
        this.crearCartas(resultado.datosVisitas, resultado.datosPagos);
        this.etiquetasVisitasHora = Utiles.obtenerClaves(resultado.visitasHora);
        this.valoresVisitasHora = Utiles.obtenerValores(resultado.visitasHora);
        let visitasSemana = Utiles.cambiarDiaSemana(resultado.visitasSemana);
        this.etiquetasVisitasSemana = Utiles.obtenerClaves(visitasSemana);
        this.valoresVisitasSemana = Utiles.obtenerValores(visitasSemana);
        this.etiquetasVisitasMes = Utiles.obtenerClaves(resultado.visitasMes);
        this.valoresVisitasMes = Utiles.obtenerValores(resultado.visitasMes);
        let pagosSemana = Utiles.cambiarDiaSemana(resultado.pagosSemana);
        this.etiquetasPagosSemana = Utiles.obtenerClaves(pagosSemana);
        this.valoresPagosSemana = Utiles.obtenerValoresPagos(pagosSemana);
        this.etiquetasPagosMes = Utiles.obtenerClaves(resultado.pagosMes);
        this.valoresPagosMes = Utiles.obtenerValoresPagos(resultado.pagosMes);
        let pagosMeses = Utiles.cambiarNumeroANombreMes(resultado.pagosMeses);
        this.etiquetasPagosMeses = Utiles.obtenerClaves(pagosMeses);
        this.valoresPagosMeses = Utiles.obtenerValoresPagos(pagosMeses);
        this.cargando = false;
      });
    },

    crearCartas(visitas, pagos) {
      this.datosVisitas = [
        {
          color: "pink darken-1",
          icono: "mdi-calendar",
          nombre: "Visitas hoy",
          total: visitas.visitasHoy,
        },
        {
          color: "red darken-1",
          icono: "mdi-calendar-range",
          nombre: "Visitas semana",
          total: visitas.visitasSemana,
        },
        {
          color: "indigo darken-1",
          icono: "mdi-calendar-month",
          nombre: "Visitas mes",
          total: visitas.visitasMes,
        },
      ];
      this.datosPagos = [

        {
          color: "teal darken-1",
          icono: "mdi-calendar",
          nombre: "Pagos hoy",
          total: "$" + pagos.pagosHoy,
        },
        {
          color: "green darken-1",
          icono: "mdi-calendar-range",
          nombre: "Pagos semana",
          total: "$" + pagos.pagosSemana,
        },
        {
          color: "orange darken-1",
          icono: "mdi-calendar-month",
          nombre: "Pagos mes",
          total: "$" + pagos.pagosMes,
        },
      ];
    },
  },
};
</script>
